const base = {
    host: 'https://pc.zdw000.com',
    api: '/api_test'
}
export default base